import { breakpointNames, breakpoints, firstBreakpointName } from '../css/breakpoints';
const makeMediaQuery = (breakpoint, styles) => Object.keys(styles).length === 0 ? {} : { [`screen and (min-width: ${breakpoints[breakpoint]}px)`]: styles };
export const responsiveStyle = (confBreak) => {
    const allRestBreak = breakpointNames
        .slice(1)
        .map(b => ({ b, s: confBreak[b] }))
        .filter((bs) => typeof bs.s !== 'undefined')
        .map(bs => makeMediaQuery(bs.b, bs.s));
    return {
        ...confBreak[firstBreakpointName],
        ...(allRestBreak.length === 0 ? {} : { '@media': allRestBreak.reduce((c, s) => ({ ...c, ...s }), {}) }),
    };
};
